import { setDefaultStyle } from "apparatus/draw";
import { P, R, Segments } from "apparatus/library/common";
import { Path } from "paper";
import { addEdgeLipsReversed, breakPathClosed, mirrorX } from "../../draw";
import { Interpolator } from "../common";
/** Interpolator, converts height to corresponding bulb size. */
const bulbDiameterLerp = new Interpolator([100, 300], [40, 136]);
/** Interpolator, converts height to corresponding neck diameter. */
const neckSizeLerp = new Interpolator([100, 300], [18, 28]);
/**
 * Based on https://scienceequip.com.au/products/distilling-flasks-fused-quartz
 */
export class DistillationFlask {
    render(appearance) {
        const height = appearance.height;
        const bulbDiameter = bulbDiameterLerp.interpolate(height);
        const neckWidth = neckSizeLerp.interpolate(height);
        const bulb = new Path.Circle(P(0, -bulbDiameter / 2), bulbDiameter / 2);
        const neck = new Path(Segments([[neckWidth / 2, -height]], [[neckWidth / 2, -20]]));
        mirrorX(neck);
        addEdgeLipsReversed(neck);
        neck.closePath();
        const outletPivot = P(0, -(height + bulbDiameter) / 2 - 10);
        const outletAngle = 17;
        const outletLength = bulbDiameter / 2 + 50;
        const outlet = new Path.Rectangle(R(0, outletPivot.y, outletLength, 12));
        outlet.rotate(outletAngle, outletPivot);
        const shape = bulb.unite(neck).unite(outlet);
        const liquidMask = shape.clone();
        const graphic = breakPathClosed(shape, 4, 8);
        setDefaultStyle(graphic);
        return {
            graphic: graphic,
            liquidMask: liquidMask,
            hitShape: graphic.bounds.toShape(),
            snapping: [
                { type: "connectable", at: P(outletLength, outletPivot.y + 6).rotate(outletAngle, outletPivot), facing: 90 + outletAngle }
            ]
        };
    }
}
DistillationFlask.properties = {
    label: "Distillation Flask",
    canContainLiquids: true,
    flippable: true,
    defaultAppearance: {
        height: 180
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "height", label: "Height",
            min: 100, max: 300
        }
    ],
};
